import React, { FC } from 'react'
import styled from 'styled-components'

const Base = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid #c0a472;
`
const B1 = styled(Base)`
  right: -4px;
  left: -4px;
`
const B2 = styled(Base)`
  top: -4px;
  bottom: -4px;
`

const Border: FC = () => (
  <>
    <B1 />
    <B2 />
  </>
)

export default Border
